import React from 'react';
import type {
  CandidateLegalTechSkill,
  GroupedExperiences,
  Taxonomy,
  User,
  BioRenderableCandidate,
} from '@axiom/validation';

import { BioPdf } from '../BioPdf/BioPdf';
import { BioView } from '../BioView/BioView';

export type TalentBiosProps = {
  name?: string;
  candidate: BioRenderableCandidate;
  clientUrl: string;
  groupedExperiences: GroupedExperiences[];
  legalTechSkills: CandidateLegalTechSkill[] | null;
  taxonomy: Taxonomy;
  user?: User;
  onNavigate?: (hideHighlights?: boolean, hideLocation?: boolean) => void;
  isDownloading?: boolean;
  hideAllHighlights?: boolean;
  hideLocation?: boolean;
  onSave?: () => void;
  isAnonymous?: boolean;
  isAhqBio?: boolean;
};

export const TalentBios = ({
  name,
  candidate,
  clientUrl,
  groupedExperiences,
  legalTechSkills,
  taxonomy,
  user,
  onNavigate,
  isDownloading = false,
  hideAllHighlights = false,
  hideLocation = false,
  onSave,
  isAnonymous = false,
  isAhqBio = false,
}: TalentBiosProps): React.JSX.Element | null => {
  return isDownloading ? (
    <BioPdf
      name={name}
      isDownloading
      onSave={onSave}
      candidate={candidate}
      groupedExperiences={groupedExperiences}
      isAnonymous={isAnonymous}
      clientUrl={clientUrl}
      hideAllHighlights={hideAllHighlights}
      hideHighlightsDetails
      hideLocation={hideLocation}
      taxonomy={taxonomy}
      legalTechSkills={legalTechSkills || []}
      isAhqBio={isAhqBio}
    />
  ) : (
    <BioView
      candidate={candidate}
      groupedExperiences={groupedExperiences}
      legalTechSkills={legalTechSkills || []}
      taxonomy={taxonomy}
      user={user}
      onNavigate={onNavigate}
      isAnonymous={isAnonymous}
    />
  );
};
